import React, { useEffect, useState } from 'react';
import { FaEye, FaEdit, FaPlus } from 'react-icons/fa';
import dayjs from 'dayjs';
import RFQItemsFormModal from './RFQItemsFormModal';
import RFQItemsViewModal from './RFQItemsViewModal';
import Sidebar from './Sidebar';
import { useNavigate } from 'react-router-dom';
const API_URL = '/api';
const RFQItemsMaster = () => {
  const [rfqs, setRfqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [showView, setShowView] = useState(false);
  const [selectedRFQ, setSelectedRFQ] = useState(null);
  const [formLoading, setFormLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [isScrolled, setIsScrolled] = useState(false);
  const [user, setUser] = useState(null);
  const [clientOnboarding, setClientOnboarding] = useState(null);
  const [allClients, setAllClients] = useState([]);
  const navigate = useNavigate();
  const token = localStorage.getItem('authToken');
  
  useEffect(() => {
    fetchProfileAndRfqs();
  }, []);
  
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  const fetchProfileAndRfqs = async () => {
    setLoading(true);
    try {
      console.log("=== FETCHING PROFILE AND RFQS ===");
      
      // 1. Get user profile (with role + userId)
      const profileRes = await fetch(`${API_URL}/profile`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const profileData = await profileRes.json();
      if (!profileData.success) throw new Error('Failed to fetch profile');
      setUser(profileData.user);
      console.log("User profile fetched:", profileData.user);
      console.log("UserID:", profileData.user.UserID);
      console.log("Role:", profileData.user.Role);
      
      // 2. Get all RFQs
      console.log("=== FETCHING RFQS ===");
      const rfqRes = await fetch(`${API_URL}/rfqs`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      let rfqData = await rfqRes.json();
      console.log("Total RFQs fetched:", rfqData.length);
      
      // Log all RFQs with their vendor codes
      console.log("=== ALL RFQS ===");
      rfqData.forEach(rfq => {
        console.log(`RFQ ID: ${rfq.id}, RFQ No: ${rfq.rfq_no}, Vendor Code: ${rfq.vendor_code}`);
      });
      
      // 3. Process RFQs based on user role
      if (profileData.user.Role === "Vendoruser") {
        // For vendor users, get client onboarding data and filter RFQs
        console.log("=== FETCHING CLIENT FOR VENDOR USER ===");
        console.log("Fetching for UserID:", profileData.user.UserID);
        
        const clientRes = await fetch(`${API_URL}/clients?user_id=${profileData.user.UserID}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const clientData = await clientRes.json();
        console.log("Client onboarding response for user:", clientData);
        
        let clientInfo = null;
        if (clientData && clientData.length > 0) {
          // Check if any of the client records match the user's ID
          const matchingClient = clientData.find(client => 
            String(client.user_id) === String(profileData.user.UserID)
          );
          
          if (matchingClient) {
            clientInfo = matchingClient;
            setClientOnboarding(clientInfo);
            console.log("=== MATCHING CLIENT FOUND ===");
            console.log("Client Info:", clientInfo);
            console.log("Client user_id:", clientInfo.user_id);
            console.log("Client vendor_code:", clientInfo.vendor_code);
          } else {
            console.log("=== NO MATCHING CLIENT FOUND ===");
            console.log("Client data exists but none match user ID:", profileData.user.UserID);
            console.log("Available client IDs:", clientData.map(c => c.user_id));
          }
        } else {
          console.log("=== NO CLIENT DATA FOUND FOR USER ===");
          console.log("No client onboarding records found for user:", profileData.user.UserID);
        }
        
        // Filter RFQs for vendor user
        if (clientInfo && clientInfo.vendor_code) {
          console.log("=== FILTERING RFQS FOR VENDOR USER ===");
          console.log("Filtering for vendor_code:", clientInfo.vendor_code);
          
          rfqData = rfqData.filter(rfq => {
            const matches = String(rfq.vendor_code) === String(clientInfo.vendor_code);
            console.log(`RFQ ${rfq.rfq_no} (vendor_code: ${rfq.vendor_code}) matches ${clientInfo.vendor_code}: ${matches}`);
            return matches;
          });
          
          console.log("=== FILTERED RFQS ===");
          console.log(`RFQs after filtering: ${rfqData.length}`);
          rfqData.forEach(rfq => {
            console.log(`RFQ ID: ${rfq.id}, RFQ No: ${rfq.rfq_no}, Vendor Code: ${rfq.vendor_code}`);
          });
        } else {
          console.log("=== NO VENDOR CODE FOUND FOR VENDOR USER ===");
          console.log("Vendor user has no client info or vendor_code");
          rfqData = [];
        }
      } else if (profileData.user.Role === "vendoradmin" || profileData.user.Role === "superadmin") {
        // For admin users, show all RFQs without filtering
        console.log("=== SHOWING ALL RFQS FOR ADMIN USER ===");
        console.log(`User role: ${profileData.user.Role}, showing all RFQs`);
      }
      
      setRfqs(rfqData);
    } catch (err) {
      console.error("=== ERROR ===");
      console.error('Error fetching profile or rfqs:', err);
      setRfqs([]);
    }
    setLoading(false);
  };
  
const getStatusClasses = (status) => {
  switch (status) {
    case 'Open':
      return 'bg-blue-600 text-white';

    case 'Bid Submitted':
      return 'bg-indigo-600 text-white';

    case 'Negotiation':
      return 'bg-amber-500 text-white';

    case 'Partially Awarded':
      return 'bg-purple-600 text-white';

    case 'Awarded':
      return 'bg-emerald-600 text-white';

    case 'Bid Closed':
      return 'bg-slate-600 text-white';

    default:
      return 'bg-gray-500 text-white';
  }
};



  
  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') direction = 'desc';
    setSortConfig({ key, direction });
    const sorted = [...rfqs].sort((a, b) => {
      if (a[key] === null) return 1;
      if (b[key] === null) return -1;
      if (key === 'rfq_date') {
        return direction === 'asc'
          ? new Date(a[key]) - new Date(b[key])
          : new Date(b[key]) - new Date(a[key]);
      }
      if (a[key] < b[key]) return direction === 'asc' ? -1 : 1;
      if (a[key] > b[key]) return direction === 'asc' ? 1 : -1;
      return 0;
    });
    setRfqs(sorted);
  };
  
  const getSortIcon = (key) => {
    if (sortConfig.key !== key) return <span className="ml-1">⇅</span>;
    return sortConfig.direction === 'asc' ? (
      <span className="ml-1">↑</span>
    ) : (
      <span className="ml-1">↓</span>
    );
  };
  
  const handleView = async (rfq) => {
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/rfqs/${rfq.id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      setSelectedRFQ(data);
      setShowView(true);
    } catch {
      setSelectedRFQ(null);
      setShowView(true);
    }
    setLoading(false);
  };
  
  const handleEdit = async (rfq) => {
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/rfqs/${rfq.id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      setSelectedRFQ(data);
      setIsEdit(true);
      setShowForm(true);
    } catch {
      setSelectedRFQ(null);
      setIsEdit(true);
      setShowForm(true);
    }
    setLoading(false);
  };
  
  const handleCreate = () => {
    setSelectedRFQ(null);
    setIsEdit(false);
    setShowForm(true);
  };
  
  const handleLogout = () => {
    localStorage.removeItem('authToken');
    navigate('/login');
  };
  
  return (
  <div className="min-h-screen flex bg-[#E5E1DA]">
    <Sidebar onLogout={handleLogout} />
    <main className="flex-1 p-2 sm:p-8 overflow-hidden ml-0 sm:ml-16 transition-all duration-300">
      <div className="flex flex-col h-full">
        {/* Header Section */}
        <div className="flex flex-col sm:flex-row justify-center sm:justify-between items-center text-center sm:items-center mb-4 sm:mb-6 gap-4">
          <h1 className="text-2xl sm:text-3xl font-bold text-[#2b6777]">Request for Quotation(RFQ)</h1>
          {/* Add Create button for admin users */}
          {(user?.Role === "vendoradmin" || user?.Role === "superadmin") && (
            <button
              onClick={handleCreate}
              className="flex items-center justify-center gap-2 px-4 py-2 bg-[#2b6777] hover:bg-[#1e4a56] text-white font-semibold rounded-lg shadow transition w-full sm:w-auto"
            >
              <FaPlus /> Create RFQ
            </button>
          )}
        </div>
        
        {/* Table Container */}
        <div className="flex-1 overflow-hidden bg-white rounded-2xl shadow-lg">
          <div className="h-full overflow-auto overflow-x-auto scroll-smooth">
            <table className="w-full min-w-[1000px] border-separate border-spacing-0">
              <thead>
                <tr>
                  <th
                    className={`sticky top-0 z-20 bg-[#AAD7D9] text-[#2b6777] px-3 sm:px-6 py-3 sm:py-4 text-center border-r border-white text-xs sm:text-sm font-bold rounded-tl-2xl cursor-pointer hover:bg-[#92C7CF] transition-all duration-300 ${
                      isScrolled ? 'shadow-lg' : ''
                    }`}
                    onClick={() => handleSort('rfq_no')}
                  >
                    <div className="flex items-center justify-center">
                      RFQ No {getSortIcon('rfq_no')}
                    </div>
                  </th>
                  <th
                    className={`sticky top-0 z-20 bg-[#AAD7D9] text-[#2b6777] px-3 sm:px-6 py-3 sm:py-4 text-center border-r border-white text-xs sm:text-sm font-bold cursor-pointer hover:bg-[#92C7CF] transition-all duration-300 ${
                      isScrolled ? 'shadow-lg' : ''
                    }`}
                    onClick={() => handleSort('rfq_date')}
                  >
                    <div className="flex items-center justify-center">
                      RFQ Date {getSortIcon('rfq_date')}
                    </div>
                  </th>
                  <th
                    className={`sticky top-0 z-20 bg-[#AAD7D9] text-[#2b6777] px-3 sm:px-6 py-3 sm:py-4 text-center border-r border-white text-xs sm:text-sm font-bold cursor-pointer hover:bg-[#92C7CF] transition-all duration-300 ${
                      isScrolled ? 'shadow-lg' : ''
                    }`}
                    onClick={() => handleSort('pr_no')}
                  >
                    <div className="flex items-center justify-center">
                      PR No {getSortIcon('pr_no')}
                    </div>
                  </th>
                  <th
                    className={`sticky top-0 z-20 bg-[#AAD7D9] text-[#2b6777] px-3 sm:px-6 py-3 sm:py-4 text-center border-r border-white text-xs sm:text-sm font-bold cursor-pointer hover:bg-[#92C7CF] transition-all duration-300 ${
                      isScrolled ? 'shadow-lg' : ''
                    }`}
                    onClick={() => handleSort('vendor_code')}
                  >
                    <div className="flex items-center justify-center">
                      Vendor Code {getSortIcon('vendor_code')}
                    </div>
                  </th>
                  <th
                    className={`sticky top-0 z-20 bg-[#AAD7D9] text-[#2b6777] px-3 sm:px-6 py-3 sm:py-4 text-center border-r border-white text-xs sm:text-sm font-bold cursor-pointer hover:bg-[#92C7CF] transition-all duration-300 ${
                      isScrolled ? 'shadow-lg' : ''
                    }`}
                    onClick={() => handleSort('payment_terms')}
                  >
                    <div className="flex items-center justify-center">
                      Payment Terms {getSortIcon('payment_terms')}
                    </div>
                  </th>
                  <th
                    className={`sticky top-0 z-20 bg-[#AAD7D9] text-[#2b6777] px-3 sm:px-6 py-3 sm:py-4 text-center border-r border-white text-xs sm:text-sm font-bold cursor-pointer hover:bg-[#92C7CF] transition-all duration-300 ${
                      isScrolled ? 'shadow-lg' : ''
                    }`}
                    onClick={() => handleSort('vendor_name')}
                  >
                    <div className="flex items-center justify-center">
                      Vendor Name {getSortIcon('vendor_name')}
                    </div>
                  </th>
                  <th
                    className={`sticky top-0 z-20 bg-[#AAD7D9] text-[#2b6777] px-3 sm:px-6 py-3 sm:py-4 text-center border-r border-white text-xs sm:text-sm font-bold cursor-pointer hover:bg-[#92C7CF] transition-all duration-300 ${
                      isScrolled ? 'shadow-lg' : ''
                    }`}
                    onClick={() => handleSort('status')}
                  >
                    <div className="flex items-center justify-center">
                      Status {getSortIcon('status')}
                    </div>
                  </th>
                  <th
                    className={`sticky top-0 z-20 bg-[#AAD7D9] text-[#2b6777] px-3 sm:px-6 py-3 sm:py-4 text-center text-xs sm:text-sm font-bold rounded-tr-2xl transition-all duration-300 ${
                      isScrolled ? 'shadow-lg' : ''
                    }`}
                  >
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td
                      colSpan={8}
                      className="text-center py-10 text-[#AAD7D9] font-semibold"
                    >
                      Loading RFQs...
                    </td>
                  </tr>
                ) : rfqs.length === 0 ? (
                  <tr>
                    <td
                      colSpan={8}
                      className="text-center py-10 text-[#AAD7D9] font-semibold"
                    >
                      {user?.Role === "Vendoruser" && clientOnboarding?.vendor_code
                        ? `No RFQs found for vendor code: ${clientOnboarding.vendor_code}` 
                        : user?.Role === "vendoradmin" || user?.Role === "superadmin"
                        ? "No RFQs available"
                        : "No vendor information available"}
                    </td>
                  </tr>
                ) : (
                  rfqs.map((rfq, idx) => (
                    <tr
                      key={rfq.id}
                      className={`transition-all duration-300 group  hover:shadow-md border-b last:border-b-0 transform hover:bg-[#eaf6f6]`}
                      style={{
                        boxShadow:
                          idx === rfqs.length - 1
                            ? '0 8px 24px 0 rgba(44,103,119,0.04)'
                            : undefined,
                      }}
                    >
                      <td className="px-3 sm:px-6 py-3 sm:py-4 text-center text-xs sm:text-sm font-mono whitespace-nowrap flex justify-center items-center">
                        <p
  className="cursor-pointer text-blue-600 hover:text-blue-800
             underline underline-offset-2 font-medium"
  onClick={() => handleView(rfq)}
>
  {rfq.rfq_no}
</p>

                      </td>
                      <td className="px-3 sm:px-6 py-3 sm:py-4 text-center text-xs sm:text-sm whitespace-nowrap">
                        {rfq.rfq_date
                          ? dayjs(rfq.rfq_date).format('DD-MM-YYYY')
                          : '-'}
                      </td>
                      <td className="px-3 sm:px-6 py-3 sm:py-4 text-center text-xs sm:text-sm whitespace-nowrap">
                        {rfq.pr_no}
                      </td>
                      <td className="px-3 sm:px-6 py-3 sm:py-4 text-center text-xs sm:text-sm whitespace-nowrap">
                        {rfq.vendor_code}
                      </td>
                      <td className="px-3 sm:px-6 py-3 sm:py-4 text-center text-xs sm:text-sm whitespace-nowrap">
                        {rfq.payment_terms}
                      </td>
                      <td className="px-3 sm:px-6 py-3 sm:py-4 text-center text-xs sm:text-sm whitespace-nowrap">
                        {rfq.vendor_name}
                      </td>
                      <td className="px-3 sm:px-6 py-3 sm:py-4 text-center text-xs sm:text-sm">
                        <span
  className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold
  tracking-wide shadow-sm whitespace-nowrap
  transition-all duration-200 ${getStatusClasses(rfq.status)}`}
>

                          {rfq.status}
                        </span>
                      </td>
                      <td className="px-3 sm:px-6 py-3 sm:py-4 flex gap-1 sm:gap-2 justify-center items-center">
                        <button
                          title="View"
                          className="p-1 sm:p-2 rounded-full hover:bg-[#c8d8e4] text-[#2b6777] transition-all duration-200 hover:scale-110"
                          onClick={() => handleView(rfq)}
                        >
                          <FaEye />
                        </button>
                        {/* Show Edit only if role is not Vendoruser AND status is Open or Negotiation */}
                       {(rfq.status === 'Open' || rfq.status === 'Negotiation') && (
  <button
    title="Edit"
    className="p-1 sm:p-2 rounded-full hover:bg-[#c8d8e4] text-[#2b6777]
               transition-all duration-200 hover:scale-110"
    onClick={() => handleEdit(rfq)}
  >
    <FaEdit />
  </button>
)}

                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
        
        {/* Modals */}
        <RFQItemsFormModal
          open={showForm}
          onClose={() => setShowForm(false)}
          onSubmit={() => {
            setShowForm(false);
            fetchProfileAndRfqs();
          }}
          initialData={selectedRFQ}
          isEdit={isEdit}
          loading={formLoading}
        />
        <RFQItemsViewModal
          open={showView}
          onClose={() => setShowView(false)}
          rfqId={selectedRFQ ? selectedRFQ.id : null}
        />
      </div>
    </main>
  </div>
);
};
export default RFQItemsMaster;